import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdminService } from 'src/app/core/services/admin-apis/admin.service';
import { FilmServiceService } from 'src/app/core/services/contest and drawing/film-service.service';

@Component({
  selector: 'app-filmcontest',
  templateUrl: './filmcontest.component.html',
  styleUrls: ['./filmcontest.component.css']
})
export class FilmcontestComponent implements OnInit {

  constructor(private service: FilmServiceService,    private router: Router ,private adminApi: AdminService   ) { }

  images:any = [];
  userId:any; 
  descriptionHeading:any
  type:any
  challengeImages: string[] = [
     'assets/images/contest/MicrosoftTeams-image (37).png',
     'assets/images/contest/MicrosoftTeams-image (38).png',
     'assets/images/contest/MicrosoftTeams-image (39).png',
     'assets/images/contest/MicrosoftTeams-image (37).png',
  ]
  
  imageObject:Array<{ image: string }> = [];

  carouselOptions = {
    loop: true,
    items: 1,
    dots: false,
    nav: true,
    navText: ["<i class='bi bi-caret-left-fill'></i>","<i class='bi bi-caret-right-fill'></i>"],
    autoplay: false,
    autoplayTimeout: 4000, // Adjust autoplay speed
    responsive: {
      0: {
        items: 1,
        margin: 10,
      },
      768: {
        items: 2,
        margin: 20,
      },
      992: {
        items: 4,
        margin: 10,
      },
      1092:{
        items: 4,
        margin: 10
      }
    },
  };

  ngOnInit(): void {
    this.service.getContestFilmDetails().subscribe((res:any)=>{
      console.log('response', res);
      this.images = res;
    })
   
    this.adminApi.getUserId().subscribe((res: any) => {
      this.userId = res.user;
    });
  }
getContest(id:any){


this.service.getFansDetails(id).subscribe((res:any)=>{
  console.log( res);
  this.descriptionHeading = res.descriptionHeading
  this.type=res.name
  this.router.navigate(['/contest/'+ this.type.replace(/ /g,'-') +'/'+ id +'/'+ this.descriptionHeading.replace(/ /g,'-')]);
})

}
}
